import { render } from "./OrderNoList.vue?vue&type=template&id=fc870300"
import script from "./OrderNoList.vue?vue&type=script&lang=js"
export * from "./OrderNoList.vue?vue&type=script&lang=js"
script.render = render

export default script